import { render } from "./SuccessPage.vue?vue&type=template&id=a93a577a&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=js"
export * from "./SuccessPage.vue?vue&type=script&lang=js"

import "./SuccessPage.vue?vue&type=style&index=0&id=a93a577a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93a577a"]])

export default __exports__